<template>
  <VDialog
    v-model="display"
    hide-overlay
    persistent
    width="300"
  >
    <VCard
      color="primary"
      dark
    >
      <VCardText>
        Loading..
        <VProgressLinear
          indeterminate
          color="white"
          class="mb-0"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: "ListLoading",
  props: {
    display: {
      type: Boolean,
      default: function () {
        return {}
      }
    },
  },
}
</script>

<style scoped>

</style>
